"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_onclickoutside_1 = require("react-onclickoutside");
var StemIcon_1 = require("../../Internal/StemIcon");
var CloseIcon_1 = require("../../Icons/CloseIcon");
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.captureClick = function (event) {
            event.stopPropagation();
        };
        return _this;
    }
    Tooltip.prototype.handleClickOutside = function (event) {
        var onClickOutsideTooltip = this.props.onClickOutsideTooltip;
        if (typeof onClickOutsideTooltip === 'function') {
            onClickOutsideTooltip(event);
        }
    };
    Tooltip.prototype.render = function () {
        var _a = this.props, className = _a.className, tooltipId = _a.tooltipId, reference = _a.reference, toggleTooltip = _a.toggleTooltip, children = _a.children;
        var iconDescription = 'Schließen';
        // The wrapper element is used as a backdrop on small screens. We listen to
        // clicks on the backdrop to close the tooltip.
        // On larger screens, the wrapper is exactly as large as the contained
        // tooltip, so the user cannot accidentally close the tooltip by clicking at
        // the wrong place.
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: className, id: tooltipId, role: "tooltip", ref: reference, onClick: toggleTooltip },
                React.createElement("div", { className: "ee_tooltip", onClick: this.captureClick },
                    React.createElement("button", { type: "button", className: "ee_tooltip__close-button", onClick: toggleTooltip, "aria-label": iconDescription },
                        React.createElement(CloseIcon_1.default, { title: iconDescription, className: "ee_tooltip__close-icon" })),
                    React.createElement("section", { className: "ee_tooltip__content" }, children)),
                React.createElement(StemIcon_1.default, { className: "ee_tooltip__stem" }))));
    };
    return Tooltip;
}(React.Component));
exports.default = react_onclickoutside_1.default(Tooltip);
//# sourceMappingURL=tooltip.js.map